export default () => {
  const postCareer = (body) => {
    try {
      return useFetch('/api/database/career', {
        method: 'POST',
        body: JSON.stringify({
          token: body.token,
          email: body.email,
          name: body.name,
          phone: body.phone,
          position: body.position,
          language: body.language,
          available: body.available,
          salary: body.salary,
          location: body.location,
          cv: body.cv,
          plan: body.plan,
          questions: body.questions,
          url: body.url,
        }),
      })
    }
    catch (error) {
      console.log(error)
    }
  }

  return {
    postCareer,
  }
}
